import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api/apiClient';

export const usePopulatedLeague = (id: string | number | undefined) => {
  return useQuery({
    queryKey: ['populatedLeague', id],
    queryFn: async () => {
      const res = await apiClient.get(`/leagues/populate/${id}`);
      return res.data.league;
    },
    enabled: !!id,
  });
}; 